// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__22eYG","colMaxWidth":"Table_colMaxWidth__3bAke"};